export namespace Sounds{
    export const DRIVE_1 = "DRIVE_1";
    export const DRIVE_2 = "DRIVE_2";
    export const DRIVE_3 = "DRIVE_3";
    export const DRIVE_4 = "DRIVE_4";
    export const ACCELERATION_1 = "ACCELERATION";
    export const SWAP_LINE = "SWAP_LINE";
    export const COL_CAR = "COL_CAR";
    export const COL_DEGEN = "COL_DEGEN";
    export const COL_UNICORN = "COL_UNICORN";
    export const COL_DPS = "COL_DPS";
    export const TAKE_ITEM = "TAKE_ITEM";
    export const USE_DEGEN = "USE_DEGEN";
    export const USE_UNICORN = "USE_UNICORN";
    export const USE_BANDITS = "USE_BANDITS";
    export const USE_DPS = "USE_DPS";
    export const BUTTON = "BUTTON";
    export const CHECKPOINT_1 = "CHECKPOINT1";
    export const CHECKPOINT_2 = "CHECKPOINT2";
    export const PURCHASE = "PURCHASE";
    export const TUNING = "TUNING";
    export const END_GAME = "END_GAME";
    export const MUSIC_MENU = "MUSIC_MENU";
    export const MUSIC_TRACK_1 = "MUSIC_TRACK_1";
    export const MUSIC_TRACK_2 = "MUSIC_TRACK_2";
}
